<div class="form form__container">
  <div class="form__header">
    <div class="form__label-title" *ngIf="viewType == FlyTicketType.FlyTicket">
      <span *ngIf="!isReturn">{{ "webPos.FlyTicketFormTitle" | translate }}</span>
      <span *ngIf="isReturn">{{ "webPos.FlyTicketRefundFormTitle" | translate }}</span>
    </div>
    <div class="form__label-title" *ngIf="viewType == FlyTicketType.ETravel">
      <span *ngIf="!isReturn">{{ "webPos.ETravel" | translate }}</span>
      <span *ngIf="isReturn">{{ "webPos.ETravelRefund" | translate }}</span>
    </div>
  </div>

  <div class="form__content">
    <form class="form__content-side" [formGroup]="flyTicketForm">
      <div class="form__content-side-form">
        <div class="form__content-side-form-row">
          <div class="form__content-side-form-row-item">
            <div class="form__content-side-form-row">
              <app-form-input label="webPos.VariableSymbol" #variableSymbolInput [type]="FormInputType.Number"
                formControlName="variableSymbol" style="margin-left: 0;" (valueChange)="disablePayments()">
              </app-form-input>

              <span class="form__content-inline-btn">
                <span class="validation-tooltip"
                  [class.validation-tooltip--disabled]="flyTicketForm.get('variableSymbol')?.invalid"
                  [attr.tabindex]="variableSymbolTooltipKey ? 0 : null"
                  [attr.aria-describedby]="variableSymbolTooltipKey ? 'variable-symbol-search-tooltip' : null">
                  <app-action-button [buttonSize]="ActionButtonSize.Smaller"
                    [disabled]="flyTicketForm.get('variableSymbol')?.invalid" (clicked)="checkExistingDocument()">
                    <fa-icon class="card-button__icon" [icon]="'magnifying-glass'"></fa-icon>&nbsp;&nbsp;{{ 'webPos.Search' | translate }}
                  </app-action-button>
                  @if (variableSymbolTooltipKey; as tooltipKey) {
                    <span class="validation-tooltip__text" id="variable-symbol-search-tooltip" role="tooltip">
                      {{ tooltipKey | translate }}
                    </span>
                  }
                </span>
              </span>
            </div>
            @if (variableSymbolErrorKey; as errorKey) {
              <span class="color--red" role="alert">{{ errorKey | translate }}</span>
            }
          </div>
          <div class="form__content-side-form-row">
            <div class="form__content-side-form-row-item">
              <app-form-input [label]="viewType == FlyTicketType.FlyTicket ? 'webPos.FlyTicketName' : 'webPos.Trip.TripName'" 
              [type]="FormInputType.Text" formControlName="flyTicketName"> <!-- 296 --> 
              </app-form-input>
            </div>
          </div>
        </div>
        <div class="form__content-side-form-row">
          <div class="form__content-side-form-row-item">
            <app-form-input label="webPos.Description" [type]="FormInputType.Text" formControlName="description">
            </app-form-input>
          </div>
        </div>

        <div class="form__content-side-form-row">
          <div class="form__content-side-form-row-item">
            <app-form-input label="webPos.Name" [type]="FormInputType.Text" formControlName="customerName">
            </app-form-input>
          </div>
          <div class="form__content-side-form-row-item">
            <app-form-input label="webPos.Surname" [type]="FormInputType.Text" formControlName="customerSurname">
            </app-form-input>
          </div>
        </div>

        <div class="form__content-side-form-row">
          <div class="form__content-side-form-row-item">
            <app-form-input label="webPos.Street" [type]="FormInputType.Text" formControlName="customerStreet">
            </app-form-input>
          </div>
          <div class="form__content-side-form-row-item">
            <app-dropdown
              [label]="'webPos.State' | translate"
              [options]="stateOptions"
              formControlName="customerCountry">
            </app-dropdown>
          </div>
        </div>

        <div class="form__content-side-form-row">
          <div class="form__content-side-form-row-item">
            <app-form-input label="webPos.City" [type]="FormInputType.Text" formControlName="customerCity">
            </app-form-input>
          </div>
          <div class="form__content-side-form-row-item">
            <app-form-input label="webPos.ZIP" [type]="FormInputType.Text" formControlName="customerZipCode">
            </app-form-input>
          </div>
        </div>

        <div class="form__content-side-form-row">
          <div class="form__content-side-form-row-item">
            <app-form-input label="webPos.Email" [type]="FormInputType.Text" formControlName="customerEmailAddress">
            </app-form-input>
          </div>
          <div class="form__content-side-form-row-item"></div>
        </div>

        <div class="form__content-side-form-row">
          <div class="form__content-side-form-row-item">
            <app-form-input label="webPos.CIN" [type]="FormInputType.Text" formControlName="customerCIN">
            </app-form-input>
          </div>
          <div class="form__content-side-form-row-item">
            <app-form-input label="webPos.TIN" [type]="FormInputType.Text" formControlName="customerTIN">
            </app-form-input>
          </div>
        </div>
      </div>
    </form>

    <div class="form__content-side">
      <div class="form__content-side-price-container">
        <app-payments [payments]="payments | async" [reservationId]="flyTicketForm?.get('variableSymbol')?.value" (paymentReturned)="checkExistingDocument()" (paymentsRefreshRequested)="checkExistingDocument()" [formEmail]="flyTicketForm?.get('customerEmailAddress')?.value"></app-payments>

        
        <div class="form__content-side-price">
          <span>{{ paymentsSummaryLabelKey | translate }}:</span>
          <span class="form__content-side-price-value">{{ paymentsSummaryValue | hcurrency : paymentsSummaryCurrency : true }}</span>
        </div>
      </div>

      <div class="payments-methods">

        @if (!isReturn && voucherCodeFromQuery) {
        <div class="sale-fly-ticket__payment-button" *ngIf="paymentAvailability.has(paymentContext, 'voucher')">
          <app-card-button [buttonSize]="CardButtonSize.Small" [buttonBackground]="CardButtonBackground.Tertiary"
            [buttonIcon]="['fas', 'gift']" [disabled]="flyTicketForm.invalid || paymentDisabled"
            (clicked)="applyGiftVoucher()">{{ 'webPos.Trip.ApplyVoucher' | translate }}</app-card-button>
        </div>
        } @else {

        <div class="sale-fly-ticket__payment-button" *ngIf="canUseReturnPaymentMethod(ReturnPaymentMethod.Cash)">
          <app-card-button [buttonSize]="CardButtonSize.Small" [buttonBackground]="CardButtonBackground.Tertiary"
            [buttonIcon]="['fas', 'money-bill-wave']" [disabled]="flyTicketForm.invalid || paymentDisabled || !canProcessCashReturn"
            (clicked)="payByCash()">
            {{ 'webPos.Cash' | translate}}
          </app-card-button>
        </div>

        <div class="sale-fly-ticket__payment-button" *ngIf="canUseReturnPaymentMethod(ReturnPaymentMethod.Card)">
          <app-card-button [buttonSize]="CardButtonSize.Small" [buttonBackground]="CardButtonBackground.Tertiary"
            [buttonIcon]="['fas', 'credit-card']"
            [disabled]="flyTicketForm.invalid || paymentDisabled || !canProcessNonCashReturn"
            [warning]="!allowPaymentByCard()"
            (clicked)="payByCard()">
            {{ 'webPos.Card' | translate}}
          </app-card-button>
        </div>
        
        <div class="sale-trip__payment-button" *ngIf="canUseReturnPaymentMethod(ReturnPaymentMethod.Benefits)">
            <app-card-button [buttonSize]="CardButtonSize.Small" 
              [buttonIcon]="['fas', 'money-check-dollar']" [disabled]="flyTicketForm.invalid || paymentDisabled || !canProcessNonCashReturn"
              [buttonBackground]="CardButtonBackground.Tertiary" (clicked)="showBenefitPaymentForm()">{{ 'webPos.Benefits' | translate }}</app-card-button>
        </div>

        <div class="sale-fly-ticket__payment-button" *ngIf="canUseReturnPaymentMethod(ReturnPaymentMethod.Other)">
          <app-card-button [buttonSize]="CardButtonSize.Small"
            [buttonIcon]="['fas', 'money-check']" [buttonBackground]="CardButtonBackground.Tertiary"
            [disabled]="flyTicketForm.invalid || paymentDisabled || !canProcessNonCashReturn"
            (clicked)="payByOthers()">{{ 'webPos.Others' | translate }}</app-card-button>
        </div>

        <div class="sale-fly-ticket__payment-button" *ngIf="isReturn && canUseReturnPaymentMethod(ReturnPaymentMethod.Voucher)">
          <app-card-button [buttonSize]="CardButtonSize.Small"
            [buttonIcon]="['fas', 'gift']" [buttonBackground]="CardButtonBackground.Tertiary"
            [disabled]="flyTicketForm.invalid || paymentDisabled"
            (clicked)="payByVoucher()">{{ 'webPos.Voucher.VoucherButton' | translate }}</app-card-button>
        </div>

        }
        

      </div>
    </div>
  </div>

  <div class="sale-fly-ticket__payment-section">

  </div>
</div>
